import React from "react";

export default function ResultsTableSkeleton() {
	return (
		<div className="card--primary__body">
			<div className="skeleton__box u-padd--huge u-mar--bottom--xsml" />
			<div className="skeleton__box u-padd--huge u-mar--bottom--xsml" />
			<div className="skeleton__box u-padd--huge" />
		</div>
	);
}
